export default {
    modalGenerateImageVariations: {
        imageAIHeader: 'Maak afbeelding met behulp van AI',
        requestFailed: 'Verzoek mislukt',
        describeYourImage: 'Omschrijf je afbeelding',
        numberOfVariations: 'Aantal variaties',
        chooseStyle: 'Kies je beeldstijl',
        descriptionPlaceholder: '(eg) Een veld met mosterd bloemen op een zomerdag met eikenbomen',
        clear: 'Duidelijk',
        generate: 'Genereren',
        seeAll: 'Bekijk alles',
        tryAnExample: 'Probeer een voorbeeld',
        tryAnother: 'Probeer een andere',
    },
};
